import { ClockIcon } from '@heroicons/react/24/outline';
import { SubPageHeader } from '@/components/shared';
import { useAuth } from '@/contexts/AuthContext';
import { OvertimeForm } from '../../components/OvertimeForm';
import { useRequestContextQuery } from '../../hooks/data/useDpRequestQueries';
import { DP_REQUESTS_PATH } from '../../routes';

export function OvertimePage() {
    const { user } = useAuth();
    const contextQuery = useRequestContextQuery(Boolean(user?.email));

    return (
        <div className="mx-auto max-w-3xl space-y-6">
            <SubPageHeader
                backPlacement="end"
                backTo={DP_REQUESTS_PATH}
                icon={<ClockIcon className="h-6 w-6" aria-hidden="true" />}
                title="Hora extra"
                description="Registre horas extras já aprovadas pelo seu gestor, para compensação ou pagamento."
            />

            {contextQuery.isPending && <div className="h-72 animate-pulse rounded-2xl bg-raro-gray-100" />}
            {contextQuery.isError && (
                <p className="rounded-2xl border border-rose-200 bg-rose-50 px-5 py-4 text-sm text-rose-800">
                    {contextQuery.error instanceof Error ? contextQuery.error.message : 'Não foi possível carregar seu cadastro.'}
                </p>
            )}
            {contextQuery.data && <OvertimeForm context={contextQuery.data} collaboratorId={user?.collaboratorId ?? ''} />}
        </div>
    );
}

export default OvertimePage;
